import { INBOX_TYPES } from 'dashboard/helper/inbox';

const META_MESSAGING_CHANNELS = new Set(
  [
    INBOX_TYPES.FB,
    INBOX_TYPES.INSTAGRAM,
    'facebook',
    'facebook_page',
    'facebookpage',
    'instagram',
    'messenger',
  ].map(channelType => channelType.toLowerCase())
);

export const shouldShowMetaMessagingWindowExpiredNotice = ({
  channelType,
  isOutsideWindow,
  isPrivateNote = false,
}) =>
  META_MESSAGING_CHANNELS.has(String(channelType || '').toLowerCase()) &&
  Boolean(isOutsideWindow) &&
  !isPrivateNote;
